import ChartBase from "./ChartBase";
export class BIBox extends ChartBase {
    constructor() {
        super();
        this._init = () => {
            // always call this
            this._getElements();
            // get custom elements
            this.valueElement = this.wrapper.querySelector("[data-value]");
        };
        this.updateData = (props) => {
            // get data and labels
            const { name, value, total } = props;
            props.metric = name;
            //set metric and question
            this._setBaseInfo(props);
            // format number when possible
            const valueString = isNaN(value) ? value : String(value).replace(/(.)(?=(\d{3})+$)/g, '$1,');
            // update value
            this.value = valueString;
            // if we have a total, set that as a title
            if (total) {
                this.setAttribute("title", `Total: ${total}`);
            }
            // remove loading
            this.loading = false;
        };
    }
    set value(value) {
        if (this.valueElement) {
            this.valueElement.textContent = value;
        }
    }
    connectedCallback() {
        // html template
        this.innerHTML = `
            <div class="dashboard-charts-bi ${this.class} dashboard-charts-item" data-wrapper>
                <div class="d-flex align-items-center mb-3">
                    <h6 class="text-muted-light text-uppercase font-weight-bold mb-0" data-metric></h6>
                </div>
                <h2 class="dashboard-charts-bi-value" data-value>0</h3>
            </div>
        `;
        this._init();
    }
}
window.customElements.define("sva-bi-box", BIBox);
